import React, { useEffect, useMemo, useState } from 'react';
import routes from 'config/config/routes';
import { antiMoneyQuestionsDisabled, antiMoneyQuestionsList } from 'const/questionsAntiMoney';
import { healthQuestionsDisabled, healthQuestionsList } from 'const/questionsHealth';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	Button,
	NavigationWrapper,
	TargetsWrapper,
	Text,
	UiWrapper,
	UserWrapper,
	View,
} from '@coinscrap/webapp-core';
import { ClientSimulationWrapper } from 'wrappers/customWrapper/ClientSimulationWrapper';
import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';
import BackNextButton from 'components/BackNextButton/BackNextButton';
import BeneficiaryForm from 'components/BeneficiaryForm/BeneficiaryForm';
import { MainModal } from 'components/MainModal/MainModal';
import { useGetError } from 'hooks/useGetError';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';
import { useSendLink } from 'hooks/useSendLink';
import { CONFIG } from '../../config/config';
import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';
import { HealthQuestions } from '../07_Questionnaires/components/HealthQuestions';
import { PbcQuestions } from '../07_Questionnaires/components/PbcQuestions';
import { AdditionalDataInputs } from './components/AdditionalDataInputs';
import { BeneficiaryList } from './components/BeneficiaryList';
import { BeneficiaryOptions } from './components/BeneficiaryOptions';
import { BeneficiaryOther } from './components/BeneficiaryOther';
import { PersonalDataInputs } from './components/PersonalDataInputs';
import { Privacity } from './components/Privacity';

export const ClientDataBase = ({ internalStep, target, user, isB2B, editMode }) => {
	const { navigateTo, goBack, replaceRoute } = NavigationWrapper.use();
	const { saveTargetProperty } = TargetsWrapper.use();
	const { updateUser } = UserWrapper.use();
	const { updateClient, updateSimulation } = ClientSimulationWrapper?.use() || {};
	const { useHeader, useFooter, useLoading, openModal } = UiWrapper.use();
	const send = useSendLink(user.id);
	const { t, i18n } = useTranslation();

	const [loading, setLoading] = useState();

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('ClientData');
	const getError = useGetError();

	// TARGET CREATION DATA
	const creationData = useMemo(
		() => target?.targetProperties?.find((x) => x.name === 'creationData')?.value,
		[target],
	);

	// ESTADO
	const [sectionTitle, setSectionTitle] = useState('');
	const [sectionSubtitle, setSectionSubtitle] = useState('');
	const [clientDataStep, setClientDataStep] = useState(false);
	useEffect(() => {
		if (internalStep) {
			setClientDataStep(internalStep);
		} else {
			setClientDataStep(1);
		}
	}, [internalStep]);

	const [beneficiariesStep, setBeneficiariesStep] = useState(1);

	const [name, setName] = useState(
		user?.name?.trim() === 'NEW_USER' ? '' : user?.name?.trim() || '',
	);
	const [surname1, setSurname1] = useState(user?.metadata.surname1?.trim() || '');
	const [surname2, setSurname2] = useState(user?.metadata.surname2?.trim() || '');

	const [gender, setGender] = useState(user?.metadata.gender?.trim() || '');

	const [municipality, setMunicipality] = useState(user?.metadata?.address?.municipality || '');
	const [addressStreetType, setAddressStreetType] = useState(
		user?.metadata?.address?.streetType || '',
	);
	const [addressStreetName, setAddressStreetName] = useState(
		user?.metadata?.address?.streetName || '',
	);
	const [addressNumber, setAddressNumber] = useState(user?.metadata?.address?.number || '');
	const [addressFloor, setAddressFloor] = useState(user?.metadata?.address?.floor || '');
	const [addressDoor, setAddressDoor] = useState(user?.metadata?.address?.door || '');

	const [email, setEmail] = useState(user?.email?.trim() || '');
	const [isEmailCorrect, setIsEmailCorrect] = useState(true);

	const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber || null);
	const [phoneNumberFixed, setPhoneNumberFixed] = useState(undefined);
	const [isPhoneNumberFixed, setIsPhoneNumberFixed] = useState(false);

	const handleSetPhoneNumber = (telefono) => {
		// console.log('telefono', telefono);

		const codigoPais = telefono?.substring(0, 3);
		// console.log('codigoPais', codigoPais);
		const restoNumero = telefono?.substring(3);
		// console.log('restoNumero', restoNumero);
		const inicioNumero = restoNumero?.substring(0, 1);
		// console.log('inicioNumero', inicioNumero);
		if (codigoPais === '+34' && restoNumero.length > 9 && inicioNumero === '0') {
			// console.log('🟡 setPhoneNumber 1', `${restoNumero?.substring(1)}`);
			setPhoneNumber(`${restoNumero?.substring(1)}`);
			setPhoneNumberFixed(`${restoNumero?.substring(1)}`);
			return;
		}
		if (phoneNumberFixed && !isPhoneNumberFixed && telefono !== `+34${phoneNumberFixed}`) {
			// console.log('🟠 setPhoneNumber 2', `+34${phoneNumberFixed}`);
			setPhoneNumber(`+34${phoneNumberFixed}`);
			setIsPhoneNumberFixed(true);
			return;
		}
		// console.log('🔴 setPhoneNumber 3', `${telefono}`);
		setPhoneNumber(telefono);
		setPhoneNumberFixed(undefined);
		setIsPhoneNumberFixed(false);
	};

	// console.log('phoneNumber', phoneNumber);

	const [advertising, setAdvertising] = useState(
		user?.metadata?.privacity?.advertising === false
			? false
			: user?.metadata?.privacity?.advertising ?? false,
	);

	const [data, setData] = useState(
		user?.metadata?.privacity?.data === false
			? false
			: user?.metadata?.privacity?.data ?? false,
	);

	const [profiling, setProfiling] = useState(
		user?.metadata?.privacity?.profiling === false
			? false
			: user?.metadata?.privacity?.profiling ?? false,
	);

	useEffect(() => {
		if (advertising === true) {
			setData(false);
			setProfiling(true);
		} else {
			setData(false);
			setProfiling(false);
		}
		return () => {};
	}, [advertising]);

	const [professionalStatus, setProfessionalStatus] = useState(
		user?.metadata.professionalStatus?.trim() || '',
	);

	const [fundsOrigin, setFundsOrigin] = useState(creationData?.fundsOrigin?.trim() || '');
	const [antiMoneyQuestionsReponses, setAntiMoneyQuestionsReponses] = useState(
		(user?.metadata?.antiMoneyQuestions || []).reduce(
			(acc, question) => ({
				...acc,
				[question.id]: question?.response,
			}),
			{},
		),
	);
	useEffect(() => {
		setAntiMoneyQuestionsReponses([]);
		return () => {};
	}, [fundsOrigin]);

	const [healthQuestionsReponses, setHealthQuestionsReponses] = useState(
		(user?.metadata?.healthQuestions || []).reduce(
			(acc, question) => ({
				...acc,
				[question.id]: question?.response,
			}),
			{},
		),
	);

	const [beneficiaryType, setBeneficiaryType] = useState(
		creationData?.details?.beneficiaryType || 'generico',
	);
	const [beneficiaries, setBeneficiaries] = useState(
		creationData?.details?.beneficiaries
			? creationData?.details?.beneficiaryType === 'expreso'
				? creationData?.details?.beneficiaries
				: []
			: [],
	);
	const [beneficiariesFormOpen, setBeneficiariesFormOpen] = useState(beneficiaries?.length === 0);
	const [otherBeneficiary, setOtherBeneficiary] = useState(
		creationData?.details?.beneficiaries
			? creationData?.details?.beneficiaries.find((ben) => ben.source === 'otros')
				? creationData?.details?.beneficiaries.find((ben) => ben.source === 'otros').name
				: ''
			: '',
	);

	const [beneficiary, setBeneficiary] = useState(undefined);
	const handleClickEditBeneficiary = (beneficiary) => {
		console.log('beneficiary', beneficiary);
		setBeneficiary(beneficiary);
		setBeneficiariesFormOpen(true);
	};
	const handleClickAddBeneficiary = () => {
		console.log('add beneficiary');
		setBeneficiary(undefined);
		setBeneficiariesFormOpen(true);
	};

	useEffect(() => {
		if (beneficiaries.length === 0) {
			setBeneficiariesFormOpen(true);
		}
	}, [beneficiaries]);

	const totalPercentage = beneficiaries.reduce(function (acc, ben) {
		return acc + ben.percentage;
	}, 0);

	// NAVIGATION
	const next = async () => {
		switch (clientDataStep) {
			case 1:
				try {
					const userPayload = {
						...user,
						username: {
							name,
							surname: `${surname1} ${surname2}`,
						},
						name,
						surname: `${surname1} ${surname2}`,
						email,
						phoneNumber,
						metadata: {
							...user?.metadata,
							surname1,
							surname2,
							gender,
							address: {
								...user?.metadata?.address,
								municipality,
								streetType: addressStreetType,
								streetName: addressStreetName,
								number: addressNumber,
								floor: addressFloor,
								door: addressDoor,
							},
							privacity: {
								advertising,
								data,
								profiling,
							},
						},
					};
					await updateUser(userPayload);
					setClientDataStep(2);
					return;
				} catch (e) {
					setLoading(undefined);
					openModal(() => <MainModal type="error" text={getError(e)} />, {
						disableClickAway: true,
						closeButton: true,
						modalClass: isMobile ? 'modal-xl' : 'modal-main',
						key: 'modal-ClientData-Step1-KO',
					});
				}
				break;
			case 2:
				try {
					const userPayload = {
						...user,
						metadata: {
							...user?.metadata,
							professionalStatus,
							antiMoneyQuestions: antiMoneyQuestionsList.map((question) => {
								return {
									id: question.id,
									question: question.description,
									response: antiMoneyQuestionsReponses[question.id],
								};
							}),
						},
					};
					await updateUser(userPayload);
					const targetPayload = {
						...creationData,
						fundsOrigin,
					};
					await saveTargetProperty(target.id, 'creationData', targetPayload);

					const cannotContinueResponses = antiMoneyQuestionsList.filter((question) => {
						if (
							question?.blocksContinue &&
							antiMoneyQuestionsReponses[question.id] ===
								question?.blocksContinueValue
						) {
							return question;
						}
						return undefined;
					});

					if (fundsOrigin === 'OTHER') {
						CONFIG.routing.clientData.koOtherOrigin(navigateTo);
					} else if (cannotContinueResponses.length > 0) {
						CONFIG.routing.pbc.ko(
							navigateTo,
							cannotContinueResponses[0].blocksContinue,
						);
					} else {
						setClientDataStep(3);
					}
				} catch (e) {
					setLoading(undefined);
					openModal(() => <MainModal type="error" text={getError(e)} />, {
						disableClickAway: true,
						closeButton: true,
						modalClass: isMobile ? 'modal-xl' : 'modal-main',
						key: 'modal-ClientData-Step2-KO',
					});
				}
				break;
			case 3:
				try {
					const userPayload = {
						...user,
						metadata: {
							...user?.metadata,
							healthQuestions: healthQuestionsList.map((question) => {
								return {
									id: question.id,
									question: question.description,
									response: healthQuestionsReponses[question.id],
								};
							}),
						},
					};
					await updateUser(userPayload);

					const cannotContinueResponses = healthQuestionsList.filter((question) => {
						if (
							question?.blocksContinue &&
							healthQuestionsReponses[question.id] === question?.blocksContinueValue
						) {
							return question;
						}
						return undefined;
					});

					if (cannotContinueResponses.length > 0) {
						CONFIG.routing.health.ko(
							navigateTo,
							cannotContinueResponses[0].blocksContinue,
						);
					} else {
						setClientDataStep(4);
					}
				} catch (e) {
					setLoading(undefined);
					openModal(() => <MainModal type="error" text={getError(e)} />, {
						disableClickAway: true,
						closeButton: true,
						modalClass: isMobile ? 'modal-xl' : 'modal-main',
						key: 'modal-ClientData-Step3-KO',
					});
				}
				break;
			case 4:
				if (beneficiaryType !== 'generico' && beneficiariesStep === 1) {
					try {
						const targetPayload = {
							...creationData,
							details: {
								...creationData?.details,
								beneficiaryType,
							},
						};
						await saveTargetProperty(target.id, 'creationData', targetPayload);
						setBeneficiariesStep(2);
					} catch (e) {
						setLoading(undefined);
						openModal(() => <MainModal type="error" text={getError(e)} />, {
							disableClickAway: true,
							closeButton: true,
							modalClass: isMobile ? 'modal-xl' : 'modal-main',
							key: 'modal-ClientData-Step4-KO',
						});
					}
				} else {
					try {
						setLoading('Actualizando...');
						const targetPayload = {
							...creationData,
							details: {
								...creationData?.details,
								beneficiaryType,
								beneficiaries:
									beneficiaryType === 'generico'
										? []
										: beneficiaryType === 'otros'
										? [
												{
													source: beneficiaryType,
													name: otherBeneficiary,
													surname: '',
													dni: '',
													percentage: 100,
												},
										  ]
										: beneficiaries,
							},
						};
						await saveTargetProperty(target.id, 'creationData', targetPayload);
						editMode
							? navigateTo(routes.activateProduct, {
									clearItems: ['internalStep', 'editMode'],
							  })
							: navigateTo(routes.identityBiometricSteps, {
									clearItems: ['internalStep'],
							  });
					} catch (e) {
						setLoading(undefined);
						openModal(() => <MainModal type="error" text={getError(e)} />, {
							disableClickAway: true,
							closeButton: true,
							modalClass: isMobile ? 'modal-xl' : 'modal-main',
							key: 'modal-ClientData-Step4-KO',
						});
					}
				}
				break;
			default:
				setLoading(undefined);
				openModal(
					() => (
						<MainModal
							type="error"
							text={getError(
								new Error(
									`clientDataStep no válido: clientDataStep ${clientDataStep}`,
								),
							)}
						/>
					),
					{
						disableClickAway: true,
						closeButton: true,
						modalClass: isMobile ? 'modal-xl' : 'modal-main',
						key: 'modal-ClientData-defaultKO',
					},
				);
				break;
		}
	};

	const isDisabled = () => {
		switch (clientDataStep) {
			case 1:
				return (
					!name ||
					!surname1 ||
					!gender ||
					!municipality ||
					!addressStreetType ||
					!addressStreetName ||
					!addressNumber ||
					/* (!addressFloor && !addressDoor) || */
					!email ||
					!isEmailCorrect ||
					!phoneNumber ||
					advertising === '' ||
					data === '' ||
					profiling === ''
				);
			case 2:
				return antiMoneyQuestionsDisabled(
					professionalStatus,
					fundsOrigin,
					user?.metadata?.documentType,
					antiMoneyQuestionsList,
					antiMoneyQuestionsReponses,
				);
			case 3:
				return healthQuestionsDisabled(healthQuestionsList, healthQuestionsReponses);
			case 4:
				if (beneficiariesStep === 1) {
					return false;
				}
				return (
					!beneficiaryType ||
					(beneficiaryType !== 'generico' &&
						((beneficiaryType === 'otros' && otherBeneficiary === '') ||
							(beneficiaryType === 'expreso' &&
								(beneficiaries.length === 0 || totalPercentage !== 100))))
				);
			default:
				return true;
		}
	};

	useEffect(() => {
		switch (clientDataStep) {
			case 1:
				setSectionTitle('Datos personales');
				setSectionSubtitle(
					'Vamos a iniciar el proceso de contatación. Para ello, necesitamos que nos facilites los siguientes datos personales.',
				);
				break;
			case 2:
				setSectionTitle('Información adicional');
				setSectionSubtitle(
					'A continuación, necesitamos que contestes unas preguntas sobre tu situación laboral.',
				);
				break;
			case 3:
				setSectionTitle('Cuestionario de salud');
				setSectionSubtitle(
					'¡Ya no queda nada! Necesitamos que nos respondas a unas preguntas básicas sobre tu estado de salud.',
				);
				break;
			case 4:
				setSectionTitle('Beneficiarios');
				setSectionSubtitle(
					'A continuación, necesitamos que indiques a quién irá destinado el capital en caso de fallecimiento.',
				);
				break;
			default:
				setSectionTitle('Datos personales');
				setSectionSubtitle(
					'Vamos a iniciar el proceso de contatación. Para ello, necesitamos que nos facilites los siguientes datos personales.',
				);
				break;
		}
		return () => {};
	}, [clientDataStep]);

	useEffect(() => {
		if (antiMoneyQuestionsList.length) {
			setAntiMoneyQuestionsReponses(
				(user?.metadata?.antiMoneyQuestions || antiMoneyQuestionsList).reduce(
					(acc, question) => ({
						...acc,
						[question.id]: question?.response,
					}),
					{},
				),
			);
		}
		if (healthQuestionsList.length) {
			setHealthQuestionsReponses(
				(user?.metadata?.healthQuestions || healthQuestionsList).reduce(
					(acc, question) => ({
						...acc,
						[question.id]: question?.response,
					}),
					{},
				),
			);
		}
		return () => {};
	}, [creationData, user]);

	useEffect(() => {
		console.log('📌 user', user);
		console.log('📌 creationData', creationData);
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (clientDataStep) {
			console.log('👉 clientDataStep', clientDataStep);
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [clientDataStep]);

	return (
		<Wrapper
			showTopSection
			step={2}
			title={sectionTitle}
			subtitle={sectionSubtitle} /* tooltip={tooltip()} */
		>
			<View innerWrapperSt>
				{
					{
						// DATOS PERSONALES
						1: (
							<>
								<PersonalDataInputs
									name={name}
									setName={setName}
									surname1={surname1}
									setSurname1={setSurname1}
									surname2={surname2}
									setSurname2={setSurname2}
									gender={gender}
									setGender={setGender}
									municipality={municipality}
									setMunicipality={setMunicipality}
									addressStreetType={addressStreetType}
									setAddressStreetType={setAddressStreetType}
									addressStreetName={addressStreetName}
									setAddressStreetName={setAddressStreetName}
									addressNumber={addressNumber}
									setAddressNumber={setAddressNumber}
									addressFloor={addressFloor}
									setAddressFloor={setAddressFloor}
									addressDoor={addressDoor}
									setAddressDoor={setAddressDoor}
									email={email}
									setEmail={setEmail}
									isEmailCorrect={isEmailCorrect}
									setIsEmailCorrect={setIsEmailCorrect}
									phoneNumber={phoneNumber}
									setPhoneNumber={handleSetPhoneNumber}
								/>

								<Privacity
									advertising={advertising}
									setAdvertising={setAdvertising}
								/>
							</>
						),
						// INFORMACIÓN ADICIONAL / PBC
						2: (
							<>
								<AdditionalDataInputs
									professionalStatus={professionalStatus}
									setProfessionalStatus={setProfessionalStatus}
									fundsOrigin={fundsOrigin}
									setFundsOrigin={setFundsOrigin}
								/>

								{professionalStatus !== '' &&
									fundsOrigin !== '' &&
									antiMoneyQuestionsList.length > 0 && (
										<PbcQuestions
											fundsOrigin={fundsOrigin}
											userDocumentType={user?.metadata?.documentType}
											antiMoneyQuestionsReponses={antiMoneyQuestionsReponses}
											setAntiMoneyQuestionsReponses={
												setAntiMoneyQuestionsReponses
											}
										/>
									)}
							</>
						),
						// SALUD
						3: (
							<>
								{healthQuestionsList.length > 0 && (
									<HealthQuestions
										healthQuestionsReponses={healthQuestionsReponses}
										setHealthQuestionsReponses={setHealthQuestionsReponses}
									/>
								)}
							</>
						),
						// BENEFICIARIOS
						4: (
							<>
								{beneficiariesStep === 1 ? (
									<BeneficiaryOptions
										beneficiaryType={beneficiaryType}
										setBeneficiaryType={setBeneficiaryType}
									/>
								) : (
									<>
										{beneficiaryType === 'expreso' && (
											<View>
												<Text
													headingTertiarySt
													style={{ alignSelf: 'flex-start' }}
												>
													Libre designación
												</Text>
												{beneficiariesFormOpen && (
													<BeneficiaryForm
														close={() =>
															setBeneficiariesFormOpen(false)
														}
														beneficiaries={beneficiaries}
														setBeneficiaries={setBeneficiaries}
														beneficiary={beneficiary}
													/>
												)}
												{beneficiaries.length > 0 && (
													<View alignItemsStartSt>
														<BeneficiaryList
															beneficiaries={beneficiaries}
															setBeneficiaries={setBeneficiaries}
															totalPercentage={totalPercentage}
															onEdit={handleClickEditBeneficiary}
														/>
														{!beneficiariesFormOpen &&
														totalPercentage !== 100 ? (
															<Button
																disabled={totalPercentage === 100}
																sameHeightAsInputsSt
																onClick={() =>
																	handleClickAddBeneficiary()
																}
															>
																{totalPercentage === 100
																	? '100% asignado'
																	: 'Añadir beneficiario'}
															</Button>
														) : null}
													</View>
												)}
											</View>
										)}
										{beneficiaryType === 'otros' && (
											<View>
												<Text
													headingTertiarySt
													style={{ alignSelf: 'flex-start' }}
												>
													Otros
												</Text>
												<BeneficiaryOther
													otherBeneficiary={otherBeneficiary}
													setOtherBeneficiary={setOtherBeneficiary}
												/>
											</View>
										)}
									</>
								)}
							</>
						),
					}[clientDataStep]
				}
			</View>

			<BackNextButton
				onClickBack={
					clientDataStep === 1
						? () => navigateTo(routes.simulation, { queryParams: { internalStep: 2 } })
						: beneficiariesStep === 2
						? () => setBeneficiariesStep(1)
						: editMode
						? () =>
								navigateTo(routes.activateProduct, {
									clearItems: ['internalStep', 'editMode'],
								})
						: () => setClientDataStep(clientDataStep - 1)
				}
				onClickNext={next}
				isNextDisabled={isDisabled()}
			/>
		</Wrapper>
	);
};
